import React from "react";
import Card from "../card";
import ListingCardSlider from "./ListingCardSlider";
import ListingCardData from "./ListingCardData";
import { Container, CardHeader, Badge } from "./styled/listing-card"; // TODO: delete this function after consolidation

function useChange(changes, changeKey) {
  var formattedChanges = Object.values(JSON.parse(changes || "{}"));
  var change = formattedChanges.reverse().find(function (change) {
    return change[changeKey];
  });

  if (change) {
    var _a = change[changeKey],
        oldPrice = _a[0],
        newPrice = _a[1];
    var parsedOldPrice = Number.isNaN(oldPrice) ? oldPrice : Number(oldPrice);
    var parsedNewPrice = Number.isNaN(newPrice) ? newPrice : Number(newPrice);
    return [parsedOldPrice, parsedNewPrice];
  }

  return [];
}

function ListingCard(_a) {
  var url = _a.url,
      photos = _a.photos,
      address = _a.address,
      city = _a.city,
      state = _a.state,
      zip = _a.zip,
      built = _a.built,
      statusLabel = _a.statusLabel,
      statusValue = _a.statusValue,
      priceChange = _a.priceChange,
      acresFormatted = _a.acresFormatted,
      priceFormatted = _a.priceFormatted,
      bedsFormatted = _a.bedsFormatted,
      bathsFormatted = _a.bathsFormatted,
      sqftFormatted = _a.sqftFormatted,
      updatedAtAgo = _a.updatedAtAgo,
      changes = _a.changes,
      // TODO: delete this prop after consolidation
  isHidden = _a.isHidden,
      footer = _a.footer,
      handleMouseEnter = _a.handleMouseEnter,
      handleMouseLeave = _a.handleMouseLeave,
      handleClick = _a.handleClick;
  var legacyChange = useChange(changes || "", "price_list");
  var oldPrice = priceChange ? priceChange[0] : legacyChange[0];
  var newPrice = priceChange ? priceChange[1] : legacyChange[1];
  return React.createElement(Container, {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, React.createElement(Card, null, React.createElement(CardHeader, null, !!oldPrice && !!newPrice && React.createElement(Badge, {
    status: statusValue
  }, newPrice < oldPrice ? "Price Reduced" : "Price Increased"), React.createElement(ListingCardSlider, {
    url: url,
    photos: photos || [],
    address: address,
    isHidden: isHidden,
    handleClick: handleClick
  })), React.createElement(Card.Body, null, React.createElement(ListingCardData, {
    url: url,
    address: address,
    city: city,
    state: state,
    zip: zip,
    built: built,
    oldPrice: oldPrice,
    newPrice: newPrice,
    isHidden: isHidden,
    statusLabel: statusLabel,
    statusValue: statusValue,
    acresFormatted: acresFormatted,
    priceFormatted: priceFormatted,
    bedsFormatted: bedsFormatted,
    bathsFormatted: bathsFormatted,
    sqftFormatted: sqftFormatted,
    updatedAtAgo: updatedAtAgo,
    handleClick: handleClick
  })), footer && React.createElement(Card.Footer, null, footer)));
}

export default ListingCard;